import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
import { Link } from "react-router-dom";

const FooterLi = ({ footer }) => {
    return (
        <>
            {footer.map((el, index) => (
                <li key={index}>
                    <Link className="text-decoration-none" style={{ fontSize: "14px", color: "white" }} to="#">
                        {el}
                    </Link>
                </li>
            ))}
        </>
    );
};

export default FooterLi;
